import { render, staticRenderFns } from "./PageToolbar.vue?vue&type=template&id=9c54a258&scoped=true&lang=pug&"
import script from "./PageToolbar.vue?vue&type=script&lang=js&"
export * from "./PageToolbar.vue?vue&type=script&lang=js&"
import style0 from "./PageToolbar.vue?vue&type=style&index=0&id=9c54a258&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c54a258",
  null
  
)

export default component.exports